import React from 'react';
import { Archive, Download, Loader2, MailCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDateTime } from '../../lib/utils';

const TRIGGER = { download: 'downloaded', email: 'emailed', issue: 'issued' };

// Immutable issued versions of one carrier document; each can be re-downloaded byte-for-byte.
export function IssuedVersions({ versions, onDownload, busyId, docType }) {
  if (!versions.length) return null;
  return (
    <div className="mt-3 ml-[52px] pl-4 border-l-2 border-gray-200 space-y-2" data-testid={'issued-versions-' + docType}>
      <p className="text-xs uppercase tracking-[0.08em] text-gray-500 flex items-center gap-1.5"><Archive className="h-3.5 w-3.5" /> Issued versions</p>
      {versions.map(function (v) {
        return (
          <div key={v.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-testid={'issued-version-' + v.id}>
            <span className="sv-mono text-xs bg-gray-100 text-ink px-1.5 py-0.5 rounded">v{v.version}</span>
            <span className="text-gray-700">{formatDateTime(v.issued_at)}</span>
            <span className="text-gray-500 text-xs">{TRIGGER[v.trigger] || v.trigger}{v.issued_by ? ' by ' + v.issued_by : ''} · {(v.size / 1024).toFixed(0)} KB</span>
            {(v.emails || []).length > 0 && (
              <span className="inline-flex items-center gap-1 text-xs text-success-700" title={v.emails.map(function (e) { return formatDateTime(e.at) + ' → ' + [...(e.to || []), ...(e.cc || [])].join(', '); }).join('\n')} data-testid={'issued-version-emailed-' + v.id}>
                <MailCheck className="h-3.5 w-3.5" /> Emailed to {[...new Set(v.emails.flatMap(function (e) { return [...(e.to || []), ...(e.cc || [])]; }))].join(', ')}
              </span>
            )}
            <Button size="sm" variant="ghost" disabled={Boolean(busyId)} className="h-7 px-2 rounded-sm text-ink ml-auto" onClick={function () { onDownload(v); }} data-testid={'issued-version-download-' + v.id}>
              {busyId === v.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Download className="h-3.5 w-3.5 mr-1" /> Download issued copy</>}
            </Button>
          </div>
        );
      })}
    </div>
  );
}
